(function () {
  'use strict';

  if (!window.theme || !window.theme.settings || window.theme.settings.cartType !== 'page') {
    return;
  }

  var popover = document.getElementById('MiniCartPopover');
  if (!popover) return;

  var itemsEl = popover.querySelector('[data-mini-cart-items]');
  var countEl = popover.querySelector('[data-mini-cart-count]');
  var subtotalEl = popover.querySelector('[data-mini-cart-subtotal]');
  var closeTimer;

  function defaultTo(value, fallback) {
    return value == null || value !== value ? fallback : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  function formatMoney(cents) {
    var format = (window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
    cents = parseInt(cents, 10) || 0;

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);

    if (!match) {
      return '$' + formatWithDelimiters(cents, 2);
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : str;
    return div.innerHTML;
  }

  function itemImageUrl(url) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_120x$1$2');
  }

  function renderCart(cart) {
    var html = '';

    cart.items.forEach(function (item) {
      html +=
        '<div class="mini-cart-popover__item">' +
        (item.image
          ? '<div class="mini-cart-popover__item-image"><img src="' +
            itemImageUrl(item.image) +
            '" alt="' +
            escapeHtml(item.product_title) +
            '" loading="lazy" width="56" height="56"></div>'
          : '<div class="mini-cart-popover__item-image"></div>') +
        '<div class="mini-cart-popover__item-details">' +
        '<div class="mini-cart-popover__item-title">' +
        escapeHtml(item.product_title) +
        '</div>' +
        (item.variant_title
          ? '<div class="mini-cart-popover__item-variant">' + escapeHtml(item.variant_title) + '</div>'
          : '') +
        '<div class="mini-cart-popover__item-meta"><span>Qty ' +
        item.quantity +
        '</span><span>' +
        formatMoney(item.final_line_price) +
        '</span></div>' +
        '</div>' +
        '</div>';
    });

    if (itemsEl) itemsEl.innerHTML = html;
    if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function updateBubbles(count) {
    document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
      el.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  function showPopover() {
    popover.classList.add('mini-cart-popover--visible');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(hidePopover, 6000);
  }

  function hidePopover() {
    popover.classList.remove('mini-cart-popover--visible');
  }

  function refreshCart() {
    return fetch(window.theme.routes.cart, { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function handleAddToCart(form) {
    var formData = new FormData(form);

    fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data && data.status) {
          form.submit();
          return null;
        }
        return refreshCart();
      })
      .then(function (cart) {
        if (!cart) return;
        renderCart(cart);
        updateBubbles(cart.item_count);
        showPopover();
      })
      .catch(function () {
        form.submit();
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
    if (!form) return;
    e.preventDefault();
    handleAddToCart(form);
  });

  document.addEventListener('click', function (e) {
    if (popover.contains(e.target)) {
      if (e.target.closest('[data-mini-cart-close]')) hidePopover();
      return;
    }
    if (e.target.closest && e.target.closest('.js-drawer-open-cart')) return;
    hidePopover();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hidePopover();
  });
})();
